export default function GS_Overview() {
  return (
    <div className="p-4">
      <h1>GS Overview</h1>
    </div>
  );
}
